<template>
  <a href="#" :class="`social-icon ${name}`"></a>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.social-icon {
  height: 36px;
  width: 36px;
}

.fb {
  background: transparent url('~@/assets/icons/fb.svg') center no-repeat;
}
.in {
  background: transparent url('~@/assets/icons/in.svg') center no-repeat;
}
.twi {
  background: transparent url('~@/assets/icons/twi.svg') center no-repeat;
}
.plus {
  background: transparent url('~@/assets/icons/plus.svg') center no-repeat;
}
</style>
